import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Store, { persistor } from './redux/store';
import AuthGate from './components/auth/AuthGate';

// Block rendering until redux-persist has rehydrated persisted state from
// localStorage. With `loading={null}` the app used to render immediately
// with an empty store → ProtectedRoute saw `auth: false` → redirected to
// login even though the user was actually logged in. Showing a minimal
// loading indicator prevents that flash redirect.
const PersistLoader = (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
    <div style={{ width: 32, height: 32, border: '3px solid #e5e7eb', borderTopColor: '#6366f1', borderRadius: '50%', animation: 'spin 0.6s linear infinite' }} />
    <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
  </div>
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={Store}>
      <PersistGate loading={PersistLoader} persistor={persistor}>
        {/* Silently exchanges the refresh cookie for an access token before
            any protected-route logic runs — see AuthGate for why. */}
        <AuthGate>
          <App />
        </AuthGate>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
